import {FormTodoType} from "./FormTodo.tsx";

export interface Validator<FormDataType> {
    fieldName: string,
    validationFunction: (data: FormDataType) => boolean,
    message: string
}

export function validatorChain<FormDataType>(key: string, data: FormDataType, validators: Array<Validator<FormDataType>>) {
    const results = [];
    if (!data.hasOwnProperty(key) || data[key] === '') {
        results.push({
            success: false,
            message: 'Veld is verplicht',
            fieldName: key
        })

        return results
    }

    for (const validator of validators) {
        if (validator.fieldName !== key)
            continue

        if (!validator.validationFunction(data)) {
            results.push({
                success: false,
                message: validator.message,
                fieldName: validator.fieldName
            })
        }
    }

    return results
}

interface ValidationResult {
    success: boolean,
    todos: Array<FormTodoType>
}

export function validateForm<FormDataType>(data: FormDataType, validators: Array<Validator<FormDataType>>): ValidationResult {
    let issueFound = false
    let formTodos: Array<FormTodoType> = []


    for (const [key, value] of Object.entries(data)) {

        const todosForThisField = validatorChain<FormDataType>(key, data, validators)

        if (todosForThisField.length > 0)
            issueFound = true

        formTodos = [...formTodos, ...todosForThisField]
    }


    return {
        success: !issueFound,
        todos: formTodos
    };
}

export function validateWebsite(value: string): boolean {
    if (!value) return false;
    const withProtocol = /^(ftp|http|https):\/\/[^ "]+$/.test(value);
    const withoutProtocol = /^[a-zA-Z0-9][a-zA-Z0-9-_.]*\.[a-zA-Z]{2,}(\/.*)?$/.test(value);
    return withProtocol || withoutProtocol;
}

export function validateVatNumber(value: string): boolean {
    const v = value?.trim().toUpperCase();
    if (!v) return true;
    return v.startsWith('NL') ? /^NL[0-9]{9}B[0-9]{2}$/.test(v) : true;
}

export function validateEmail(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}
